import { render, staticRenderFns } from "./support.vue?vue&type=template&id=72ab6965"
import script from "./support.js?vue&type=script&lang=js&external"
export * from "./support.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports